import React, { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import { apiClient } from "../utils/API/apiClient";

const YouTubeConnectPage: React.FC = () => {
  const { user, openAuthModal } = useAuth();
  const [status, setStatus] = useState<{ isConnected: boolean; channelName?: string } | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user?.sub) {
      fetchStatus();
    } else {
      setLoading(false);
    }
  }, [user]);

  const fetchStatus = async () => {
    try {
      const response = await apiClient<{ isConnected: boolean; channelName?: string }>(
        `/api/youtube/status?userId=${user?.sub}`,
        { apiType: 2 }
      );
      setStatus(response.data);
    } catch (error) {
      console.error("Failed to fetch YouTube status:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleConnect = () => {
    if (!user) {
      openAuthModal();
      return;
    }
    const backendUrl = "https://socialmediawebappdotnet-c5gvgzgqauekgmej.westindia-01.azurewebsites.net";
    window.location.href = `${backendUrl}/api/youtube/connect?userId=${user.sub}`;
  };

  const handleDisconnect = async () => {
    if (!window.confirm("Are you sure you want to disconnect your YouTube account?")) return;
    
    try {
      await apiClient(`/api/youtube/disconnect?userId=${user?.sub}`, {
        method: "DELETE",
        apiType: 2,
      });
      setStatus({ isConnected: false });
    } catch (error) {
      console.error("Failed to disconnect YouTube:", error);
      alert("Failed to disconnect. Please try again.");
    }
  };

  if (loading) {
    return <div style={{ padding: "40px", textAlign: "center" }}>Checking connection status...</div>;
  }

  return (
    <div style={{ padding: "20px" }}>
      <h2 style={{ color: "#714B67", marginBottom: "20px", fontWeight: 800 }}>YouTube Integration</h2>

      <div style={{
        background: "#fff",
        padding: "30px",
        borderRadius: "16px",
        boxShadow: "0 10px 30px rgba(0,0,0,0.06)",
        maxWidth: "500px"
      }}>
        {status?.isConnected ? (
          <div>
            <div style={{ display: "flex", alignItems: "center", marginBottom: "20px" }}>
              <div style={{ 
                width: "50px", 
                height: "50px", 
                borderRadius: "50%", 
                background: "#FF0000", 
                display: "flex", 
                alignItems: "center", 
                justifyContent: "center",
                color: "#fff",
                marginRight: "15px",
                fontSize: "20px"
              }}>
                YT
              </div>
              <div>
                <h3 style={{ margin: 0, color: "#2D3748" }}>{status.channelName}</h3>
                <p style={{ margin: 0, color: "#666", fontSize: "14px" }}>Connected</p>
              </div>
            </div>
            <p style={{ color: "#4A5568", fontSize: "15px", lineHeight: "1.6" }}>
              Your YouTube account is successfully linked. You can now manage your video settings and uploads directly from SocialFlow.
            </p>
            <div style={{ display: "flex", gap: "12px", marginTop: "24px" }}>
              <button
                onClick={handleConnect}
                style={{
                  flex: 1,
                  padding: "12px 20px",
                  borderRadius: "10px",
                  border: "2px solid #714B67",
                  background: "transparent",
                  color: "#714B67",
                  cursor: "pointer",
                  fontWeight: 700,
                  transition: "all 0.2s"
                }}
              >
                Reconnect
              </button>
              <button
                onClick={handleDisconnect}
                style={{
                  flex: 1,
                  padding: "12px 20px",
                  borderRadius: "10px",
                  border: "none",
                  background: "#FEE2E2",
                  color: "#DC2626",
                  cursor: "pointer",
                  fontWeight: 700,
                  transition: "all 0.2s"
                }}
              >
                Disconnect
              </button>
            </div>
          </div>
        ) : (
          <div>
            <h3 style={{ marginBottom: "15px", color: "#2D3748" }}>Not Connected</h3>
            <p style={{ color: "#666", fontSize: "15px", lineHeight: "1.6", marginBottom: "25px" }}>
              Connect your YouTube channel to SocialFlow to automate your video management, extract tags, and optimize your SEO.
            </p>
            <button
              onClick={handleConnect}
              style={{
                padding: "12px 24px",
                borderRadius: "8px",
                border: "none",
                background: "#714B67",
                color: "#fff",
                cursor: "pointer",
                fontWeight: 600,
                fontSize: "16px"
              }}
            >
              Connect YouTube Now
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default YouTubeConnectPage;
